<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    persistent
    transition="dialog-transition"
    max-width="500px"
  >
    <v-card tile>
      <v-toolbar dense>
        <v-btn @click="closeDialog()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title class="subtitle-1">New Expenses Group</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn class="mr-2 text-none primary darken-4" @click="createExpensesGroup()">Create</v-btn>
      </v-toolbar>

      <v-card-text class="mx-0 px-0">
        <v-form class="pa-4" ref="form" @submit.prevent v-model="valid" lazy-validation>
          <v-text-field
            v-model="title"
            :rules="titleRules"
            autofocus
            label="Title"
            color="primary darken-4"
            :class="{ 'mb-3': !valid }"
            outlined
            dense
            validate-on-blur
          ></v-text-field>

          <v-textarea
            v-model="description"
            label="Description"
            color="primary darken-4"
            validate-on-blur
            hide-details
            :rows="1"
            outlined
            dense
            auto-grow
          ></v-textarea>
        </v-form>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NewExpensesGroupDialog",
  data() {
    return {
      valid: true,
      title: "",
      titleRules: [v => !!v || "title is required"],
      description: ""
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setNewExpensesGroupDialog", false);
      this.$refs.form.reset();
    },

    async createExpensesGroup() {
      if (this.$refs.form.validate()) {
        var data = {
          branch: this.branchId,
          title: this.title,
          description: this.description
        };

        await this.$store
          .dispatch("createExpensesGroup", data)
          .then(() => {
            this.$refs.form.reset();
          })
          .catch(error => error);
      }
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.newExpensesGroupDialog;
    },

    branchId: {
      get() {
        if (this.$route.params.branchId) return this.$route.params.branchId;
        else return "";
      },

      set: function() {
        return;
      }
    }
  }
};
</script>

<style>
</style>